import { BaseForm, Validators } from '../FormBuilder';

export class SupplierNcrEditSummaryForm extends BaseForm {
    constructor(props) {
        // Create an object that will represent the structure of the form.
        // This should include a definition for each field within the form (i.e. name, value, label etc.).
        // This will be passed to the constructor of the base class "BaseForm".
        const formDefinition = {
            fields: [
                {
                    name: "statusId",
                    label: "Status",
                    editor: {
                        name: "dropdown",
                        options: props.statusOptions
                    },
                    validators: [
                        Validators.required()
                    ]
                },
                {
                    name: "classificationTypeId",
                    label: "Classification Type",
                    editor: {
                        name: "dropdown",
                        options: props.classificationTypeOptions
                    },
                    validators: [
                        Validators.required()
                    ]
                },
                {
                    name: "defectTypeId",
                    label: "Defect Type",
                    editor: {
                        name: "dropdown",
                        options: props.defectTypeOptions
                    }
                },
                {
                    name: "quantityAffected",
                    label: "Quantity Affected",
                    validators: [
                        Validators.required()
                    ],
                    editor: "number"
                },   
                {
                    name: "isMaterialsRejected",
                    label: "Were Materials Rejected?",
                    editor: "checkbox"
                }, 
                {
                    name: "description",
                    label: "Description of Issue",
                    validators: [
                        Validators.required()
                    ],
                    editor: "textarea"
                }                 
            ]
        };

        // Call the constructor of the base class.
        // As we are passing in the formDefintion and the form data (props.data),
        // This should setup the form accordingly.
        super(props, formDefinition, props.data);
    }

    getModel(fields) {
        // This function will override the logic to generate the model that is returned after submitting the form.
        // The generated model will be passed to the relevant handleSave() event, where it can be used to process the data accordingly.

        // Get the model that is generated by the BaseForm.
        // This gets the value for each field defined within the form and returns it as an object.
        // We can use this as the base model to work from and modify it accordingly before we return it.    
        const model = {
            ...this._getModel(fields),
            statusId: fields.statusId.value * 1,
            classificationTypeId: fields.classificationTypeId.value * 1,
            defectTypeId: fields.defectTypeId.value * 1
        };

        return model;
    }
}



